import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { prodApi } from "./prodApi";
import ProdLogin from "./ProdLogin";
import ProdLayout from "./ProdLayout";
import ProdDashboard from "./ProdDashboard";
import ProdQuickYield from "./ProdQuickYield";
import ProdRuns from "./ProdRuns";
import ProdRunDetail from "./ProdRunDetail";
import ProdCascade from "./ProdCascade";
import ProdSimulations from "./ProdSimulations";
import ProdRecipes from "./ProdRecipes";
import ProdRecipeEditor from "./ProdRecipeEditor";
import ProdTree from "./ProdTree";
import ProdStats from "./ProdStats";
import ProdUsers from "./ProdUsers";

const ProdContext = createContext(null);
export const useProd = () => useContext(ProdContext);

export default function ProdApp() {
  const [boot, setBoot] = useState(null);
  const [checking, setChecking] = useState(true);

  const reload = useCallback(async () => {
    const r = await prodApi.get("/production/bootstrap");
    setBoot(r.data);
    return r.data;
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("prod_token")) { setChecking(false); return; }
    reload().catch(() => localStorage.removeItem("prod_token")).finally(() => setChecking(false));
  }, [reload]);

  const logout = () => { localStorage.removeItem("prod_token"); setBoot(null); };
  const onLogin = async (token) => { localStorage.setItem("prod_token", token); await reload(); };

  const value = useMemo(() => {
    const nodes = boot?.nodes || [];
    return {
      user: boot?.user, nodes, trims: boot?.trim_levels || [], recipes: boot?.recipes || [], empty: !!boot?.empty,
      nodeById: Object.fromEntries(nodes.map((n) => [n.id, n])), reload, logout,
    };
  }, [boot, reload]);

  if (checking) {
    return (
      <div className="min-h-screen bg-[#0F172A] flex items-center justify-center">
        <p className="font-['Chivo'] font-black text-3xl text-white tracking-tighter">PRODU<span className="text-blue-500">ZIONE</span></p>
      </div>
    );
  }
  if (!boot) return <ProdLogin onLogin={onLogin} />;

  return (
    <ProdContext.Provider value={value}>
      <ProdLayout user={boot.user} onLogout={logout}>
        <Routes>
          <Route index element={<ProdDashboard />} />
          <Route path="resa-rapida" element={<ProdQuickYield />} />
          <Route path="lavorazioni" element={<ProdRuns />} />
          <Route path="lavorazioni/:id" element={<ProdRunDetail />} />
          <Route path="calcolatore" element={<ProdCascade />} />
          <Route path="simulazioni" element={<ProdSimulations />} />
          <Route path="simulazioni/:id" element={<ProdSimulations />} />
          <Route path="ricette" element={<ProdRecipes />} />
          <Route path="ricette/nuova" element={<ProdRecipeEditor />} />
          <Route path="ricette/:id" element={<ProdRecipeEditor />} />
          <Route path="albero" element={<ProdTree />} />
          <Route path="storico" element={<ProdStats />} />
          <Route path="utenti" element={<ProdUsers />} />
          <Route path="*" element={<Navigate to="/produzione" replace />} />
        </Routes>
      </ProdLayout>
    </ProdContext.Provider>
  );
}
